import { render, staticRenderFns } from "./wheelAct.vue?vue&type=template&id=200137f4&scoped=true&"
import script from "./wheelAct.vue?vue&type=script&lang=js&"
export * from "./wheelAct.vue?vue&type=script&lang=js&"
import style0 from "./wheelAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wheelAct.vue?vue&type=style&index=1&id=200137f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200137f4",
  null
  
)

component.options.__file = "wheelAct.vue"
export default component.exports